const UserActionType =
{
    CHOICE_CLICKED: "CHOICE_CLICKED",
    CHAT_TEXT_ENTER: "CHAT_TEXT_ENTER",
    COUNTRY_SELECT: "COUNTRY_SELECT",
    SNS_CLICKED: "SMART_SEARCH_CLICK",
    CATEGORY_OPTION_CLICKED: "CATEGORY_OPTION_CLICK",
    FEEDBACK_CLICK: 'FEEDBACK_CLICK',
    RETRY_CLICK: 'RETRY_CLICK',
    CREATE_SR: 'CREATE_SR',
    DT_LINK_CLICK: 'DT_LINK_CLICK'
}

export default UserActionType;


// WEBPACK FOOTER //
// ./src/enums/UserActionType.js